import React, {useEffect} from 'react';
import {CustomConfig, PageConstructor} from '@gravity-ui/page-constructor';

import {Lang} from '~shared/models/settings';

// Импортим явно, т.к. из promo на эти слайсы нет завязок
// Однако initialState c сервера приходит
import '~ui/store/slices/user';
import '~ui/store/slices/global';

import {useStateSelector} from '~ui/hooks';
import {crossReachGoal} from '~ui/services/metrika';

import {SHOW_GOAL} from '../../constants';
import {selectPromoContent} from '../../store';

import {PromoPageFooter} from '../PromoPageFooter';
import {PromoPageHeader} from '../PromoPageHeader';
import {PromoPageCard} from '../PromoPageCard';

import {cnPromoPage} from './PromoPage.classname';

import './PromoPage.scss';

interface PromoPageProps {
    lang?: Lang;
}

const customConfig: CustomConfig = {
    subBlocks: {
        card: PromoPageCard,
    },
};

export const PromoPage: React.FC<PromoPageProps> = ({lang = Lang.Ru}) => {
    const content = useStateSelector(selectPromoContent);

    useEffect(() => {
        crossReachGoal(SHOW_GOAL);
    }, []);

    return (
        <div className={cnPromoPage()}>
            <PromoPageHeader content={content} />
            <PageConstructor content={content} custom={customConfig} />
            <PromoPageFooter lang={lang} />
        </div>
    );
};
